module.exports = __webpack_public_path__ + "media/images/xpass/token-a548ef3d9017fb99d9a5c833a80a19f2.png";